export function vertraag<T>(waarde: T, ms = 240): Promise<T> {
  return new Promise((resolve) => {
    setTimeout(() => resolve(waarde), ms)
  })
}
